import {dayjs} from "@euroland/libs";

import weekOfYear from "dayjs/plugin/weekOfYear";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);

export default dayjs;
